import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import Bamboo from '../bamboo.jsx';
import {Helmet} from 'react-helmet';
import OpenPositions from '../open-positions.jsx';
import {isIE} from 'react-device-detect';


class Career extends Component {
  constructor (props) {
    super(props)
  }

  render() {
    if(isIE) {
      return (
        <div className="single-page career" id="single-page">
          <Helmet>
            <title>Open positions</title>
            <link rel="canonical" href={location.protocol + '//' + location.host} />
            <meta property="og:title" content="Open positions" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={location.href} />
            <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
          </Helmet>

          <div className="content-wrapper dark">
            <h1 className="section-subheading">JOIN THE TEAM</h1>
            <div className="section-heading">are you ready to</div>
            <div className="section-heading">join the challenge?</div>
            <div id="BambooHR-ATS">
              <Bamboo/>
            </div>
          </div>
          <div className="section-background">
            <h1 className="section-subheading">Can't find what you're looking for?</h1>
            <div className="section-heading">WE BELIEVE IN PEOPLE</div>
            <div className="section-heading light">NOT TITLES.</div>
            <a href="mailto:hr@bethardgroup.com" className="button-link" target="_blank">Get in touch  </a>
          </div>
        </div>
      );
    }
    else {
      return (
        <div className="single-page career" id="single-page">
          <Helmet>
            <title>Open positions</title>
            <link rel="canonical" href={location.protocol + '//' + location.host} />
            <meta property="og:title" content="Open positions" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={location.href} />
            <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
          </Helmet>

          <div className="content-wrapper open-positions">
            <OpenPositions />
          </div>
          <div className="content-wrapper dark">
            <h1 className="section-subheading">JOIN THE TEAM</h1>
            <div className="section-heading">are you ready to</div>
            <div className="section-heading">join the challenge?</div>
            <div id="BambooHR-ATS">
              <Bamboo/>
            </div>
          </div>
          <div className="section-background">
            <h1 className="section-subheading">Can't find what you're looking for?</h1>
            <div className="section-heading">WE BELIEVE IN PEOPLE</div>
            <div className="section-heading light">NOT TITLES.</div>
            <a href="mailto:hr@bethardgroup.com" className="button-link" target="_blank">Get in touch  </a>
          </div>
        </div>
      );
    }
  }
}

export default Career;



// WEBPACK FOOTER //
// ./client/components/pages/career.jsx